import script from "./PreSportsSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportsSlider.vue?vue&type=script&setup=true&lang=js"

import "./PreSportsSlider.vue?vue&type=style&index=0&id=eab20720&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eab20720"]])

export default __exports__